import React from "react";
import CollectionFacet from "./facets/CollectionFacet";
import BrandFacet from "./facets/BrandFacet";
import SubBrandFacet from "./facets/SubBrandFacet";
import ColorFacet from "./facets/ColorFacet";
import ApplicationFacet from "./facets/ApplicationFacet";
import ApplicationMultipleFacet from "./facets/ApplicationMultipleFacet";
import ColorVariationFacet from "./facets/ColorVariationFacet";
import ConstructionFacet from "./facets/ConstructionFacet";
import InstallationMethodFacet from "./facets/InstallationMethodFacet";
import LocationFacet from "./facets/LocationFacet";
import SpeciesFacet from "./facets/SpeciesFacet";
import TextureFacet from "./facets/TextureFacet";
import ThicknessFacet from "./facets/ThicknessFacet";
import WearLayerThicknessFacet from "./facets/WearLayerThicknessFacet";
import StyleFacet from "./facets/StyleFacet";
import ShadeFacet from "./facets/ShadeFacet";
import ShapeFacet from "./facets/ShapeFacet";
import LookFacet from "./facets/LookFacet";
import MaterialFacet from "./facets/MaterialFacet";
import Material from "./facets/Material";
import FiberFacet from "./facets/FiberFacet";
import BackingFacet from "./facets/BackingFacet";
import HeightFacet from "./facets/HeightFacet";
import WidthFacet from "./facets/WidthFacet";
import SampleAvailableFacet from "./facets/SampleAvailableFacet";
import VisualizableFacet from "./facets/VisualizableFacet";
import DesignFacet from "./facets/DesignFacet";
import GroupFacet from "./facets/GroupFacet";
import SizeFacet from "./facets/SizeFacet";
import PriceFacet from "./facets/PriceFacet";
import CustomFacet from "./facets/CustomFacet";
import ResetFilters from "./facets/ResetFilters";
import RemoveFilters from "./RemoveFilters";

function ProductFilters({
  isOpen,
  toggleFlyer,
  plpFacetLabel,
  searchText,
  handleFilterChange,
  hasActiveFilters,
  handleResetFilter,
  filters,
  handleRemoveFilter,
  plpFacets,
  productSamples,
  handleFilterSample,
  selectedSample,
  productVisualizables,
  handleFilterVisualizable,
  selectedVisualizable,
  productBrands,
  handleFilterClick,
  productSubBrands,
  productCustom,
  productGroup,
  productSize,
  productPrice,
  productCollections,
  handleCheckboxChange,
  selectedCollection,
  productApplications,
  initialApplicationFacet,
  productStyle,
  productColorVariations,
  productConstructions,
  productColors,
  productInstallationMethods,
  productLocations,
  productSpecies,
  productLook,
  productMaterial,
  productMaterialFacet,
  productDesign,
  productFiber,
  productBacking,
  productTextures,
  productShade,
  productShape,
  productThickness,
  productWearLayerThickness,
  productHeight,
  productWidth,
}) {
  const { sub_type, ...newFilters } = filters;
  return (
    <div
      className={`col-lg-3 col-md-3 col-sm-4 facet_filters ${
        isOpen ? "open" : ""
      }`}>
      <div className="close_bar">
        <a
          className="close close_sidebar"
          onClick={toggleFlyer}
          href="javascript:void(0)">
          <i className="fa fa-close">&nbsp;</i>
        </a>
      </div>
      <div className="facet_wrap">
        <strong>
          {plpFacetLabel &&
          Object.keys(plpFacetLabel)?.length > 0 &&
          plpFacetLabel.hasOwnProperty("search") &&
          plpFacetLabel.search != ""
            ? plpFacetLabel.search
            : "Search"}
        </strong>
        <div className="facetwp-facet">
          <input
            type="text"
            className="search_input"
            placeholder="Search Keyword"
            value={searchText}
            onChange={(e) => handleFilterChange("search", e.target.value)}
          />
        </div>
      </div>
      {hasActiveFilters && (
        <>
          <ResetFilters handleResetFilter={handleResetFilter} />
          <RemoveFilters
            filters={newFilters}
            handleRemoveFilter={handleRemoveFilter}
          />
        </>
      )}
      {plpFacets.map((facet, index) => {
        switch (facet) {
          case "sample_available_facet":
            return (
              Object.keys(productSamples).length > 0 &&
              productSamples["Yes"] && (
                <SampleAvailableFacet
                  key={index}
                  handleFilterSample={handleFilterSample}
                  productSamples={productSamples}
                  selectedSample={selectedSample}
                />
              )
            );

          case "visualizable_facet":
            return (
              Object.keys(productVisualizables).length > 0 &&
              productVisualizables["Yes"] && (
                <VisualizableFacet
                  key={index}
                  handleFilterVisualizable={handleFilterVisualizable}
                  productVisualizables={productVisualizables}
                  selectedVisualizable={selectedVisualizable}
                />
              )
            );

          case "brand_facet":
            return (
              Object.keys(productBrands).length > 0 && (
                <BrandFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productBrands={productBrands}
                />
              )
            );

          case "sub_brand":
            return (
              Object.keys(productSubBrands).length > 0 && (
                <SubBrandFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productSubBrands={productSubBrands}
                />
              )
            );
          case "custom":
            return (
              Object.keys(productCustom).length > 0 && (
                <CustomFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productCustom={productCustom}
                />
              )
            );
          case "group":
            return (
              Object.keys(productGroup).length > 0 && (
                <GroupFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productGroup={productGroup}
                />
              )
            );

          case "size_facet":
            return (
              Object.keys(productSize).length > 0 && (
                <SizeFacet
                  handleFilterClick={handleFilterClick}
                  productSize={productSize}
                />
              )
            );
          case "price_facet":
            return (
              Object.keys(productPrice).length > 0 && (
                <PriceFacet
                  handleFilterClick={handleFilterClick}
                  productPrice={productPrice}
                />
              )
            );

          case "collection_facet":
            return (
              Object.keys(productCollections).length > 0 && (
                <CollectionFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productCollections={productCollections}
                  handleCheckboxChange={handleCheckboxChange}
                  selectedCollection={selectedCollection.collection_facet || []}
                />
              )
            );

          case "application_facet":
            return (
              Object.keys(productApplications).length > 0 && (
                <ApplicationFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productApplications={productApplications}
                />
              )
            );

          case "application_multiple_facet":
            return (
              Object.keys(productApplications).length > 0 && (
                <ApplicationMultipleFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productApplications={initialApplicationFacet}
                  productApplicationsDynamic={productApplications}
                  selectedApplications={
                    filters.application_facet?.split(",") || []
                  }
                />
              )
            );

          case "style_facet":
            return (
              Object.keys(productStyle).length > 0 && (
                <StyleFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productStyle={productStyle}
                />
              )
            );

          case "color_variation_facet":
            return (
              Object.keys(productColorVariations).length > 0 && (
                <ColorVariationFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productColorVariations={productColorVariations}
                />
              )
            );

          case "construction_facet":
            return (
              Object.keys(productConstructions).length > 0 && (
                <ConstructionFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productConstructions={productConstructions}
                />
              )
            );

          case "color_facet":
            return (
              Object.keys(productColors).length > 0 && (
                <ColorFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productColors={productColors}
                />
              )
            );

          case "installation_method":
            return (
              Object.keys(productInstallationMethods).length > 0 && (
                <InstallationMethodFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productInstallationMethods={productInstallationMethods}
                />
              )
            );

          case "location_facet":
            return (
              Object.keys(productLocations).length > 0 && (
                <LocationFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productLocations={productLocations}
                />
              )
            );

          case "species_facet":
            return (
              Object.keys(productSpecies).length > 0 && (
                <SpeciesFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productSpecies={productSpecies}
                />
              )
            );

          case "look_facet":
            return (
              Object.keys(productLook).length > 0 && (
                <LookFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productLook={productLook}
                />
              )
            );

          case "material":
            return (
              Object.keys(productMaterial).length > 0 && (
                <Material
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productMaterial={productMaterial}
                />
              )
            );

          case "material_facet":
            return (
              Object.keys(productMaterialFacet).length > 0 && (
                <MaterialFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productMaterial={productMaterialFacet}
                />
              )
            );

          case "design":
            return (
              Object.keys(productDesign).length > 0 && (
                <DesignFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productDesign={productDesign}
                />
              )
            );

          case "fiber":
            return (
              Object.keys(productFiber).length > 0 && (
                <FiberFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productFiber={productFiber}
                />
              )
            );

          case "backing_facet":
            return (
              Object.keys(productBacking).length > 0 && (
                <BackingFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productBacking={productBacking}
                />
              )
            );

          case "surface_texture_facet":
            return (
              Object.keys(productTextures).length > 0 && (
                <TextureFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productTextures={productTextures}
                />
              )
            );

          case "shade_facet":
            return (
              Object.keys(productShade).length > 0 && (
                <ShadeFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productShade={productShade}
                />
              )
            );

          case "shape_facet":
            return (
              Object.keys(productShape).length > 0 && (
                <ShapeFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productShape={productShape}
                />
              )
            );

          case "thickness_facet":
            return (
              Object.keys(productThickness).length > 0 && (
                <ThicknessFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productThickness={productThickness}
                />
              )
            );
          case "wear_layer_thickness_facet":
            return (
              Object.keys(productWearLayerThickness).length > 0 && (
                <WearLayerThicknessFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productWearLayerThickness={productWearLayerThickness}
                />
              )
            );

          case "height":
            return (
              Object.keys(productHeight).length > 0 && (
                <HeightFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productHeight={productHeight}
                />
              )
            );

          case "width":
            return (
              Object.keys(productWidth).length > 0 && (
                <WidthFacet
                  key={index}
                  handleFilterClick={handleFilterClick}
                  productWidth={productWidth}
                />
              )
            );

          default:
            return null;
        }
      })}

      <div className="close_sidebar_button">
        <a
          className="fl-button close_sidebar"
          onClick={toggleFlyer}
          href="javascript:void(0)">
          <span className="fl-button-text">View Results</span>
        </a>
      </div>
    </div>
  );
}

export default ProductFilters;
